import React, { useState, useEffect } from 'react';
import "../resources/resources.css";
import HNavbar from '../../Components/Navbar/HNavbar';
import MFooter from '../../Components/Main-Footer/MFooter';
import SEO from '../../Components/SEO';

function Resources() {
    const [showTopBtn, setShowTopBtn] = useState(false);

    useEffect(() => {
        const handleScroll = () => {
            if (window.scrollY > 400) {
                setShowTopBtn(true);
            } else {
                setShowTopBtn(false);
            }
        };
        window.addEventListener('scroll', handleScroll);

        return () => window.removeEventListener('scroll', handleScroll);
    }, []);

    return (
        <>
            <SEO
                title="Environmental Noise Control & Noise Barrier Design"
                description="Technical resources for environmental noise control and noise barrier design, including product brochures, specifications and installation guides."
                canonical="https://www.soundbarrier.in/resources"
            />
            <HNavbar />
            {/* ===== HERO ===== */}
            <section className="resource-sb-hero">
                <div className="container">
                    <div className="row align-items-center">
                        <div className="col-lg-6 col-xl-5">
                            <div className="resource-hero-tag">RESOURCES</div>
                            <h1 className="resource-hero-title">
                                Knowledge. Standards. Solutions.
                            </h1>
                            <p className="resource-hero-desc">
                                Our resource library brings together global standards, reference materials and trusted acoustic literature to support best practices in acoustics and noise control.
                            </p>

                            <div className="d-flex flex-wrap gap-3 my-3 resource-feature-icons-row">
                                {[
                                    { icon: "fa fa-bar-chart", label: "High Noise Reduction" },
                                    { icon: "fa fa-cloud", label: "Weather Resistant" },
                                    { icon: "fa fa-bolt", label: "Fast Installation" },
                                    { icon: "fa fa-refresh", label: "Reusable System" },
                                    { icon: "fa fa-shield", label: "Suitable for Indoor & Outdoor" },
                                ].map((f) => (
                                    <div className="resource-feature-icon-item" key={f.label}>
                                        <i className={f.icon}></i>
                                        <span>{f.label}</span>
                                    </div>
                                ))}
                            </div>

                            <div className="d-flex flex-wrap gap-2 mt-2">
                                <a href="/contactus" className="btn2 btn2-orange d-inline-flex align-items-center gap-2">
                                    REQUEST A QUOTE&nbsp;<i className="fa fa-arrow-right"></i>
                                </a>
                                <a href="https://www.soundbarrier.in/pdfs/SOUND%20BARRIER%20-%20Technical%20Data%20Sheet.pdf" className="btn2 btn2-outline-dark-sb d-inline-flex align-items-center gap-2" target="_blank"
                                    rel="noopener noreferrer">
                                    DOWNLOAD BROCHURE&nbsp;<i className="fa fa-download"></i>
                                </a>
                            </div>
                        </div>
                    </div>
                </div>
            </section>

            <section style={{ background: "#f8f8f8" }}>
                <div className='container'>
                    <div className="row">
                        <div className="col-sm-6 col-md-6 d-flex flex-column align-items-center mt-4">
                            <h5 className='key-benefits'>STANDARDS & GUIDELINES</h5>
                            <div className='kb d-flex flex-column gap-2'>
                                {["ISO 354-Measurement of sound absorption in a reverberation room", "ISO 10140-Laboratory measurement of sound insulation", "ASTM C423-Standard Test Method for Sound Absorption", "ASTM E90-Laboratory measurement of airborne sound transmission loss", "ISO 3382-Measurement of room acoustic parameters", "ISO 1996-Assessment of environmental noise", "ASTM E84-Surface burning characteristics of building materials"].map((item) => (
                                    <div className="challenge-item" key={item}>
                                        <i className="fa fa-check-circle"></i>
                                        <span>{item}</span>
                                    </div>
                                ))}
                            </div>
                        </div>
                        <div className="col-sm-6 col-md-6">
                            <div className="tested-certified-box d-flex flex-column justify-content-center align-items-center">
                                <h5>ACOUSTIC LITERATURE & GUIDES</h5>
                                <div className="cert-grid">
                                    <div className="cert-item">
                                        <div className="cert-icon"><i className="fa-solid fa-file-lines"></i></div>
                                        <div className="cert-text">
                                            <strong>Technical White Papers</strong>
                                            <span>In-depth insights on acoustic materials and testing</span>
                                        </div>
                                    </div>
                                    <div className="cert-item">
                                        <div className="cert-icon"><i className="fa-solid fa-clipboard-list"></i></div>
                                        <div className="cert-text">
                                            <strong>Application Guides</strong>
                                            <span>Practical design guides for diverse environments</span>
                                        </div>
                                    </div>
                                    <div className="cert-item">
                                        <div className="cert-icon"><i className="fa-solid fa-graduation-cap"></i></div>
                                        <div className="cert-text">
                                            <strong>Acoustic Fundamentals</strong>
                                            <span>Basics of sound, noise control and room acoustics</span>
                                        </div>
                                    </div>
                                    <div className="cert-item">
                                        <div className="cert-icon"><i className="fa-solid fa-chart-line"></i></div>
                                        <div className="cert-text">
                                            <strong>Case Studies</strong>
                                            <span>Real-world acoustic solutions and project outcomes</span>
                                        </div>
                                    </div>
                                    <div className="cert-item">
                                        <div className="cert-icon"><i className="fa-solid fa-file-arrow-down"></i></div>
                                        <div className="cert-text">
                                            <strong>Datasheets & Test Reports</strong>
                                            <span>Product data and certifications</span>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
            {showTopBtn && (
                <button className='scroll-to-top'
                    onClick={() => window.scrollTo({ top: 0, behavior: 'smooth' })}
                > ↑ </button>
            )
            }
            <MFooter />
        </>
    )
}

export default Resources